import { DatePicker, Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';
import { OptionalNote } from './OptionalNote';

type ScheduledContentProps = {
  callDate: Date;
  setCallDate: (date: Date) => void;
  minDate: Date;
  control: Control<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
};

export const ScheduledContent = (props: ScheduledContentProps) => {
  return (
    <div className='flex flex-col gap-4 items-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          <div className='flex flex-col gap-1 w-full'>
            <div className='text-sm'>
              When are you scheduled to meet? We'll check back in after this date.
            </div>
            <DatePicker
              additionalClassNames={'w-full md:w-[500px]'}
              initialDate={props.callDate}
              onChange={(newDate) => props.setCallDate(newDate)}
              minDate={props.minDate}
            />
          </div>
          <OptionalNote control={props.control} />
        </>
      }
    </div>
  );
};
